<script context="module">
	// this allows an importer to do e.g.
	// `import Example, { alertTotal } from './Example.svelte'`
	/*
	export function alertTotal() {
		alert(totalComponents);
	}
	*/

	const myAudioContext = new AudioContext();

/**
 * Helper function to emit a beep sound in the browser using the Web Audio API.
 * 
 * @param {number} duration - The duration of the beep sound in milliseconds.
 * @param {number} frequency - The frequency of the beep sound.
 * @param {number} volume - The volume of the beep sound.
 * 
 * @returns {Promise} - A promise that resolves when the beep sound is finished.
 */
export function Beep(duration, frequency, volume){
    return new Promise((resolve, reject) => {
        // Set default duration if not provided
        duration = duration || 200;
        frequency = frequency || 440;
        volume = volume || 100;

        try{
            let oscillatorNode = myAudioContext.createOscillator();
            let gainNode = myAudioContext.createGain();
            oscillatorNode.connect(gainNode);

            // Set the oscillator frequency in hertz
            oscillatorNode.frequency.value = frequency;

            // Set the type of oscillator
            oscillatorNode.type= "square";
            gainNode.connect(myAudioContext.destination);

            // Set the gain to the volume
            gainNode.gain.value = volume * 0.01;

            // Start audio with the desired duration
            oscillatorNode.start(myAudioContext.currentTime);
            oscillatorNode.stop(myAudioContext.currentTime + duration * 0.001);

            // Resolve the promise when the sound is finished
            oscillatorNode.onended = () => {
                resolve();
            };
        }catch(error){
            reject(error);
        }
    });
}
</script>

<script>
	import { onMount, beforeUpdate,afterUpdate } from "svelte";
	import { requestNotificationPermission, showNotification } from "./notification";
	import { TimerWorker } from "./worker/index";
	import {
		Button,
		Container,
		Header,
		Dropdown,
		initDropdown,
		controllable, 
		Input,
		Segment,
		List,
		Menu,
		MenuItem,
		Item,
		initItem,
		Divider,
		Icon,
		Text,
		Label,
	} from "svantic";

		initItem(),initDropdown()

	import { Grid, Row, Column } from "svantic";

	import { GameContainer } from "./components/gamecontainer/index";
	import { ToggleBox, ToggleBoxGrid } from "./components/togglebox";
	import DraggableCard from "./components/draggablecard/draggablecard.svelte";
	//import Betamount from "./components/betconfig/betamount.svelte";

	
	import {SiteSettings, Chat_De, Chat_Challenges, ApiKey, setStakeMirror, User, BetSettingsLocal, CurrencyConversionRates, Mirror } from "./stores";


	import { Balance } from "./components/balance";
	import { Chat } from "./components/chat";
	import Betconfig from "./components/gamecontainer/betconfig.svelte";

	let dropdown_game;
	let i_key;

	console.log("Beep: ", Beep)
	
	const DropdownGameController = controllable(controller=>{
		// called when the module is mounted and ready
		// access the controller and manupilate dropdown
			controller.setSelected("dice")
		})
	
	const DropdownMirrorController = controllable(controller=>{
		// called when the module is mounted and ready
		// access the controller and manupilate dropdown
			controller.setSelected($Mirror)
		})
	

	if($ApiKey && $ApiKey.lengthb > 10)
			i_key = $ApiKey

	onMount( () => {

		if(window){
			window.setStakeMirror = setStakeMirror
		}
		requestNotificationPermission()
	//	showNotification("Stake Bot", "Hello!")
		return () => {
			// function on unmount

		};
	});

	let showNotifactions = false

	const notificationHandler = (event) => {
		showNotifactions = event.detail.checked
	}

	$: {
		SiteSettings.update({notifications: showNotifactions})
	}
</script>

<Menu
	fixed
	borderless
	size="small"
	style={{ "background-color": "#1f5f8f" }}
	class="main-nav">
	<Container>
		
		<Dropdown
			item
			size="small" 
			style={{ "min-width": "120px" }}
			bind:this={$DropdownGameController}
			onMount={async (elem) => {
				console.log("dropdown 'game' element ", elem)
			}}
			settings={{					
				onChange: (value, text, $selectedItem) => {
					console.log("dropdown game onChange: ", value )
					dropdown_game = value.toLowerCase(); // custom action

				},
			}}>
			<input name="game" type="hidden"  />

			<!-- <Dropdown.text>Select game</Dropdown.text> -->
			<Dropdown.Text>Select game</Dropdown.Text>
			<i class="ui dropdown icon" />
			<Dropdown.Menu>				
				<Dropdown.Item value="diamonds">Diamonds</Dropdown.Item>
				<Dropdown.Item  value="dice">Dice</Dropdown.Item>
				<Dropdown.Item  value="dragontower">DragonTower</Dropdown.Item>
				<Dropdown.Item value="hilo">Hilo</Dropdown.Item>
				<Dropdown.Item value="keno">Keno</Dropdown.Item>
				<Dropdown.Item  value="limbo">Limbo</Dropdown.Item>

				<Dropdown.Item value="mines">Mines</Dropdown.Item>
				
				<Dropdown.Item value="plinko">Plinko</Dropdown.Item>
				<Dropdown.Item value="packs">Packs</Dropdown.Item>
				<Dropdown.Item value="samurai">Samurai</Dropdown.Item>
				<Dropdown.Item value="scarab">Scarab</Dropdown.Item>
				<Dropdown.Item value="tomeoflife">TomeOfLife</Dropdown.Item>
				<Dropdown.Item  value="videoPoker">VideoPoker</Dropdown.Item>

				<Dropdown.Item value="wheel">Wheel</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>

	

		<MenuItem class="center aligned">
			{#if $User.name.length == 0}
			<Input labeled="left" color="blue" size="small" 	type="password"	bind:value={i_key}	on:input={() => {
				if (i_key.length > 10) {
					$ApiKey = i_key;
				}
			}}>
				<Label color="orange" slots="left">api</Label>
			
			</Input>
		{:else}
			<Balance />	
		{/if}
				
		</MenuItem>

		<Dropdown
			item
			size="small" 
			style={{ "min-width": "120px" }}
			bind:this={$DropdownMirrorController}
			onMount={async (elem) => {
				console.log("dropdown 'Stake Mirror ' element ", elem)
			}}
			settings={{					
				onChange: (value, text, $selectedItem) => {
					console.log("dropdown Stake Mirror onChange: ", value )
					$Mirror = value.toLowerCase(); // custom action

				},
			}}>
			<input name="game" type="hidden"  />

			<!-- <Dropdown.text>Select game</Dropdown.text> -->
			<Dropdown.Text>Stake Mirror</Dropdown.Text>
			<i class="ui dropdown icon" />
			<Dropdown.Menu>				
				<Dropdown.Item value="bet">bet</Dropdown.Item>
				<Dropdown.Item  value="bz">bz</Dropdown.Item>
				<Dropdown.Item  value="ac">ac</Dropdown.Item>
				<Dropdown.Item  value="jp">jp</Dropdown.Item>			
				<Dropdown.Item value="games">games</Dropdown.Item>
				<Dropdown.Item value="eu">eu</Dropdown.Item>
				
			</Dropdown.Menu>
		</Dropdown>

		<MenuItem >
				<ToggleBox on:change={notificationHandler} iconName="bell outline" borderRadius="50%" backgroundColorChecked="transparent" textColor="#999" textColorChecked="#fff"></ToggleBox>			
		</MenuItem>
	</Container>
</Menu>

<Container padded class="margin-top">
	<Segment raised>
		<GameContainer game={dropdown_game} />
	</Segment>
</Container>

<DraggableCard
	title="Component Preview"
	left="60"
	top="130"
	visible={false}
	css={{ borderColor: "#e0b041", textColor: "#dae8f3" }}>

	<div slot="content" class="keno-selection-container">
		<Segment>
			<p>Extra Settings</p>
			
		</Segment>

	</div>

</DraggableCard>

<DraggableCard
	title="Chat - DE "
	left="40"
	top="130"
	width="120"
	height="60"
	visible={false}
	autoScroll={true}
	css={{ borderColor: "#1f5f8f", textColor: "#dae8f3" }}>
	<Chat.Messages slot="content" items={[...$Chat_De]} />
	<Chat.Form slot="bottom" />
</DraggableCard>

<style>
	:global(body) {
		background-color: #212121;
		padding-top: 6.0em !important;
	}

	:global(.margin-top) {
		/*	margin-top: 6.5rem !important;*/
	}
	:global(input[type="text"], input[type="number"]) {
		font-weight: bold;
	}

	:global(.ui.menu.main-nav .item) {
		background-color: #1f5f8f;
		color: #edf7ff;
	}

	.coin-symbol {
		margin-block: 8px !important;
	}

	.flex-container{
		display:flex;
		justify-content:center;
		align-items:center;
		align-content:center;
		
	}

	.flex-item {
		flex: 0 0 auto;
		padding: 2px;
   		 margin: 2px;
		width: 36px;
		height: 36px;
		border: 1px solid rgb(105, 105, 105);
		background-color: #ececec;
	}

	
	/*
	.coin-symbol::after {
		content: attr(data-coin);
		padding-left: 0.3em;
		font-style: italic;
		font-size: 0.75em;
		font-weight: 600;
	}
	*/

	
</style>
